module.exports = __webpack_public_path__ + "static/media/rsmnumDescending.bd92b260.svg";